import { Dialog, DialogFooter, Icon } from "@fluentui/react";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Form, Formik } from "formik";
import { FormSpinner } from "../../components/FormSpinner";
import {
  Flex,
  HSpace,
  StyledPrimaryButton,
  VSpace,
} from "../../components/styled";
import { useSelector } from "../../store/hooks";
import {
  exportToZipRoutine,
  setExportToZipDialog,
} from "../../store/locations-page/locationsPage";
import ComboBoxField from "../../components/controls/ComboBoxField";

export const ExportToZipDialog = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { locationId } = useSelector((s) => s.locationsPage.exportToZipDialog);
  const isLoading = useSelector(
    (s) => s.locationsPage.exportToZipLoadStatus === "loading",
  );
  const reports = useSelector((s) => s.reports.entities);

  const locationReports = useMemo(() => {
    return Object.values(reports).filter(
      (r) => r.locationId === locationId && r.isReportDeactivated === false,
    );
  }, [reports, locationId]);

  const reportIdOptions = useMemo(() => {
    return locationReports.map((r) => ({
      value: r.reportId,
      label: r.reportName,
    }));
  }, [locationReports]);

  const initialValues = useMemo(() => {
    return {
      reportIds: [],
    };
  }, []);

  const close = () => {
    dispatch(
      setExportToZipDialog({
        locationId: null,
        isOpen: false,
      }),
    );
  };

  const onSubmit = (data: {
    reportIds: { value: number; label: string }[];
  }) => {
    const payload = {
      locationId: locationId,
      body: {
        reportIds: data?.reportIds?.map((item) => item?.value) || [],
      },
    };
    dispatch(exportToZipRoutine.trigger(payload));
  };

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        showCloseButton: true,
        title: (
          <Flex>
            <Icon iconName="Info" /> <HSpace />
            <div>{t("ram.locationList.context.exportToZip")}</div>
          </Flex>
        ),
      }}
      onDismiss={close}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ values, errors, setFieldValue, submitForm }) => (
          <Form>
            <ComboBoxField
              isMulti
              required={false}
              disabled={false}
              errors={errors}
              name="reportIds"
              label={"ram.recommendations.column.reports.label"}
              setFieldValue={setFieldValue}
              options={reportIdOptions}
              defaultValue={values?.reportIds}
              confidentiality={null}
            />
            <VSpace height={10} />
            <div>{t("ram.locationList.context.exportToZip.success")}</div>
            <DialogFooter>
              <StyledPrimaryButton
                text={t("ram.locationList.context.exportToZip")}
                onClick={submitForm}
                disabled={isLoading}
              />
            </DialogFooter>
            {isLoading && <FormSpinner />}
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};
